"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.schemaSistemaAvaliacao = exports.yupSistemaAvaliacao = void 0;
const yup = __importStar(require("yup"));
const enums_1 = require("../enums");
exports.yupSistemaAvaliacao = yup.object({
    anoletivo: yup.number().default(0).positive().label('Ano Letivo'),
    nome: yup.string().default('').max(80).required().label('Nome'),
    nomeAbreviado: yup.string().default('').max(30).required().label('Nome Abreviado'),
    //-> Aba Medias
    mediaAp: yup.number().default(0).positive().label('Média Anual para Aprovação Direta'),
    mediaRec: yup.number().default(0).positive().label('Média para Aprovação após Exame/Recuperação'),
    mediaMin: yup.number().default(0).positive().label('Média Mínima para entrar no Exame/Recuperação'),
    mediaBim: yup.number().default(0).label('Média para Recuperação Paralela'),
    arreAjuda: yup.number().default(0).label('Pontos extras para ajudar o aluno a atingir a média'),
    maxBim1: yup.number().default(0).label('Nota máxima do 1º Bimestre'),
    maxBim2: yup.number().default(0).label('Nota máxima do 2º Bimestre'),
    maxBim3: yup.number().default(0).label('Nota máxima do 3º Bimestre'),
    maxBim4: yup.number().default(0).label('Nota máxima do 4º Bimestre'),
    pesoBimD: yup.boolean().required().default(false).label('Usar pesos nos bimestres'),
    pesoSemD: yup.boolean().required().default(false).label('Usar pesos nos semestres'),
    pesoBim1: yup.number().default(1).positive().label('Peso do Bimestre 1'),
    pesoBim2: yup.number().default(1).positive().label('Peso do Bimestre 2'),
    pesoBim3: yup.number().default(1).positive().label('Peso do Bimestre 3'),
    pesoBim4: yup.number().default(1).positive().label('Peso do Bimestre 4'),
    pesoSem1: yup.number().default(1).positive().label('Peso do Semestre 1'),
    pesoSem2: yup.number().default(1).positive().label('Peso do Semestre 2'),
    tipoava: yup
        .mixed()
        .oneOf(Object.values(enums_1.ESistAvalTipoAva))
        .required()
        .default(enums_1.ESistAvalTipoAva['Avaliação por notas'])
        .label('Forma de Avaliação'),
    numeroBim: yup
        .mixed()
        .oneOf((0, enums_1.enumValues)(enums_1.ESistAvalNumeroEtapa))
        .required()
        .default(enums_1.ESistAvalNumeroEtapa['4 Bimestres'])
        .label('Número de Etapas'),
    usavirgula: yup
        .mixed()
        .oneOf(Object.values(enums_1.ESistAvalUsaVirgula))
        .required()
        .default(enums_1.ESistAvalUsaVirgula['Não utilizar vírgula'])
        .label('Configuração de Vírgula'),
    virgula: yup.boolean().required().default(false).label('Formatar Notas com Vírgula'),
    //-> Aba Recuperacao
    //Recuperacao Bimestral/Semestral
    recBim: yup.boolean().required().default(false).label('Recuperação Bimestral'),
    recSem: yup.boolean().required().default(false).label('Recuperação Semestral'),
    calcRecP: yup
        .mixed()
        .oneOf(Object.values(enums_1.ESistAvalCalcRecP))
        .required()
        .default(enums_1.ESistAvalCalcRecP['Média Aritmética'])
        .label('Cálculo da Recuperação Bimestral/Semestral'),
    pesoMedia: yup.number().default(0).label('Peso da Média Bimestral/Semestral'),
    pesoRec: yup.number().default(0).label('Peso da Recuperação Bimestral/Semestral'),
    mediaMax: yup.number().default(0).label('Média Máxima após Recuperação Bimestral/Semestral'),
    maSemestr: yup.boolean().required().default(false).label('Calcular MA pelos Semestres'),
    bimrecant: yup
        .boolean()
        .required()
        .default(false)
        .label('Usar a nota do bimestre como Recuperação do Bimestre Anterior'),
    calcsemMb: yup.boolean().required().default(false).label('Média Semestral igual ao Maior Bimestre'),
    //Recuperacao Final
    recFinal: yup.boolean().required().default(false).label('Possui Recuperação Final'),
    recRNome: yup.string().default('Rec. Final').max(15).label('Nome da Recuperação Final'),
    calcRecF: yup
        .mixed()
        .oneOf(Object.values(enums_1.ESistAvalCalcRecF))
        .default(enums_1.ESistAvalCalcRecF['Média Aritmética'])
        .label('Cálculo da Recuperação Final'),
    pesoRRec: yup.number().default(1).label('Peso da Recuperação Final'),
    pesoRMed: yup.number().default(1).label('Peso da média anual para Recuperação'),
    mediaMaxr: yup.number().default(0).label('Média Máxima após a Recuperação Final'),
    pesoRDiv: yup.number().default(1).label('Divisão da Recuperação Final'),
    //Exame Final
    recExame: yup.boolean().required().default(false).label('Possui Exame Final'),
    recENome: yup.string().default('Exame').max(15).label('Nome do Exame'),
    calcExaF: yup
        .mixed()
        .oneOf(Object.values(enums_1.ESistAvalCalcExaF))
        .default(enums_1.ESistAvalCalcExaF['Média Aritmética'])
        .label('Cálculo do Exame'),
    pesoERec: yup.number().default(1).label('Peso do Exame'),
    pesoEMed: yup.number().default(1).label('Peso da Média Anual para o Exame'),
    mediaMaxe: yup.number().default(0).label('Média Maxima do Exame'),
    pesoEDiv: yup.number().default(1).label('Divisão do Exame'),
    //-> Aba Secretaria/Diretor
    secretariaNome: yup.string().default('').max(40).label('Secretário(a) Nome'),
    secretariaRg: yup.string().default('').max(26).label('Secretário(a) Rg'),
    secretariaAto: yup.string().default('').max(15).label('Secretario(a) Ato'),
    secretariaTitulo: yup.string().default('').max(20).label('Secretário(a) Título'),
    diretorNome: yup.string().default('').max(40).label('Diretor(a) Nome'),
    diretorRg: yup.string().default('').max(26).label('Diretor(a) Rg'),
    diretorAto: yup.string().default('').max(15).label('Diretor(a) Ato'),
    diretorTitulo: yup.string().default('').max(20).label('Diretor(a) Título'),
    titulo: yup.string().default('').max(80).label('Título'),
    diretora: yup.string().default('').max(40).label('Diretor(a)'),
    //-> Aba Sintese Avaliacao
    sinteseAvaliacao: yup.string().default('').max(500).label('Síntese do Sistema de Avaliação'),
    //-> Aba Opcoes
    // Medias
    mostrarDecimais: yup.boolean().required().default(false).label('Mostrar as casas decimais'),
    arreMedia: yup.boolean().required().default(false).label('Usar Arredondamento de Médias'),
    arrMed5d: yup.boolean().required().default(false).label('Arredondar médias de 5 em 5 pontos'),
    consMaAp: yup.boolean().required().default(false).label('Considerar M.A. para aprovação após Exame'),
    mediaArr: yup.number().default(0).label('Valor a somar no Arredondamento de Médias'),
    exaReduz: yup.boolean().required().default(false).label('Manter M.A. se Rec. ou Exame for menor que a M.A.'),
    pesoB14D: yup
        .boolean()
        .required()
        .default(false)
        .label('Usar os pesos dos bimestres/semestres também para o Fundamental I'),
    recbReduz: yup
        .boolean()
        .required()
        .default(false)
        .label('Manter a nota do bimestre, se for mal da Recuperação Paralela'),
    rec4b: yup.boolean().required().default(false).label('Fica em Recuperação se a nota do 4º Bim ficou abaixo da média'),
    consEfAp: yup
        .boolean()
        .required()
        .default(false)
        .label('Considerar Rec. ou Exame maior que zero e M.F. maior ou igual a média para aprovação'),
    csMa: yup.boolean().required().default(false).label('Não alterar a Média Anual ao Aprovar pelo Conselho'),
    csMf: yup.boolean().required().default(false).label('Não alterar a Média Final ao Aprovar pelo Conselho'),
    calcMs: yup.boolean().required().default(false).label('Usar cálculo semestral mesmo usando Recuperação Bimestral'),
    // Boletins
    mostBAst: yup.boolean().required().default(false).label('Mostrar (*) Asterísco nos Boletins'),
    grafBol: yup.boolean().required().default(false).label('Imprimir Gráfico nos Boletins'),
    // grafColor: yup.boolean().required().default(false).label('Imprimir Gráfico Colorido nos Boletins'),
    faltBMat: yup.boolean().required().default(false).label('Imprimir faltas nos boletins por matéria'),
    // impLogoBol: yup.boolean().required().default(false).label('Imprimir logotipo da escola nos boletins'),
    depadp: yup.boolean().required().default(false).label('Imprimir Adaptação e Dependência nos boletins'),
    impmaparc: yup.boolean().required().default(false).label('Não Imprimir M.A. antes da última etapa'),
    impdocpen: yup.boolean().required().default(false).label('Imprimir documentos pendentes no boletim'),
    impverme: yup.boolean().required().default(false).label('Imprimir notas abaixo da média em vermelho no boletim'),
    maSoma: yup.boolean().required().default(false).label('Calcular MA pela Soma dos Bimestres'),
    // Documentos Oficiais - tem na tabela MatrizCurricular
    titulo1: yup.string().default('').max(60, 'Máximo de 60 caracteres.').label('Título do Curso Fundamental'),
    lei1: yup.string().default('').max(200, 'Máximo de 200 caracteres.').label('Lei no Relatório Final do Fundamental'),
    titulo2: yup.string().default('').max(60, 'Máximo de 60 caracteres.').label('Título do Curso Ens. Médio'),
    lei2: yup.string().default('').max(200, 'Máximo de 200 caracteres.').label('Lei no Relatório Final do Ens. Médio'),
    diasletivo: yup.number().default(0).label('Dias letivos anuais previstos para o Ano'),
    horasaula1: yup.number().default(0).label('Duração de cada aula no Fundamental em minutos'),
    horasdia1: yup.string().default('').max(5).label('Número de horas por dia no Fundamental'),
    horasaula2: yup.number().default(0).label('Duração de cada aula no Ens. Médio em minutos'),
    horasdia2: yup.string().default('').max(5).label('Número de horas por dia no Ens. Médio'),
    horasajus1: yup.number().default(0).label('Ajuste no total de horas do Fundamental'),
    horasajus2: yup.number().default(0).label('Ajuste no total de horas do Ens. Médio'),
    diasbim1: yup.number().default(0).label('Dias letivos do 1º bimestre'),
    diasbim2: yup.number().default(0).label('Dias letivos do 2º bimestre'),
    diasbim3: yup.number().default(0).label('Dias letivos do 3º bimestre'),
    diasbim4: yup.number().default(0).label('Dias letivos do 4º bimestre'),
    totdiaslet: yup.number().default(0).label('Total de dias letivos'),
    totcargaho: yup.number().default(0).label('Carga horária total'),
    totalch1: yup.number().default(0).label('Carga horária do Fundamental'),
    totalch2: yup.number().default(0).label('Carga horária do Ens. Médio'),
    leiHist1: yup.string().default('').max(15).label('Lei no Histórico do Fundamental'),
    leiHist2: yup.string().default('').max(15).label('Lei no Histórico do Ens. Médio'),
    logoescola: yup.string().default('').max(60, 'Máximo de 60 caracteres.').label('Logo da Escola'),
    logoestado: yup.string().default('').max(60, 'Máximo de 60 caracteres.').label('Logo do Estado'),
    implogodoc: yup.boolean().required().default(false).label('Imprimir Logotipo nos Documentos'),
    modeloBol: yup.string().default('').max(3).label('Modelo do boletim'),
    apDp: yup.boolean().required().default(false).label('Aprovar alunos com dependência'),
    numDp: yup.number().default(0).label('Máximo de matérias reprovadas para aprovar com dependência'),
    dep14: yup.boolean().required().default(false).label('Aprovar alunos c/ dependência no Ens. Fundamental'),
    finalAno: yup.boolean().required().default(false).label('finalAno'),
    modDocs: yup.string().default('').max(1).label('Modelo dos documentos'),
    //-> Nao usa Mais no Sistema
    pesoMa: yup.number().default(0).label('Peso da Média Anual'),
    pesoEx: yup.number().default(0).label('Peso do Exame'),
    // Perdido na Tabela
    impdescdia: yup.boolean().required().default(false).label('Desconto apenas para pgto em dia.'),
});
exports.schemaSistemaAvaliacao = exports.yupSistemaAvaliacao.shape({});
